import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../config/firebaseConfig";
import { signOut } from "firebase/auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle, faSignOutAlt, faUserCog } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { toast } from "react-hot-toast";

const AdminHeader = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const user = auth.currentUser;
    const menuRef = useRef(null);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleLogout = async () => {
        setIsMenuOpen(false);
        const result = await Swal.fire({
            title: "Logout?",
            text: "Are you sure you want to log out?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, logout"
        });

        if (result.isConfirmed) {
            try {
                await signOut(auth);
                navigate('/login');
                toast.success("Logged out successfully");
            } catch (err) {
                console.error("Logout error:", err);
                toast.error("Failed to log out");
            }
        }
    };

    return (
        <header className="bg-white border-b border-gray-200 h-16 flex items-center justify-end px-8 sticky top-0 z-40">
            <div className="relative" ref={menuRef}>
                <button
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    className="flex items-center gap-3 hover:bg-gray-100 p-1.5 rounded-full transition-colors cursor-pointer"
                >
                    <div className="text-right hidden md:block">
                        <p className="text-sm font-semibold text-gray-800 leading-none">Admin</p>
                        <p className="text-xs text-gray-500 mt-1">{user?.email}</p>
                    </div>
                    <FontAwesomeIcon icon={faUserCircle} className="text-3xl text-gray-600" />
                </button>

                {isMenuOpen && (
                    <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-xl border border-gray-100 py-2 animate-in fade-in zoom-in duration-200">
                        <div className="px-4 py-3 border-b border-gray-50">
                            <p className="text-xs font-bold text-gray-400 uppercase tracking-wider">Account</p>
                            <p className="text-sm font-medium text-gray-800 truncate">{user?.email}</p>
                        </div>

                        <button
                            onClick={() => {
                                setIsMenuOpen(false);
                                navigate('/settings');
                            }}
                            className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-3 transition-colors cursor-pointer"
                        >
                            <FontAwesomeIcon icon={faUserCog} className="text-blue-500" />
                            Profile Settings
                        </button>

                        <div className="my-1 border-t border-gray-50"></div>

                        <button
                            onClick={handleLogout}
                            className="w-full text-left px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 flex items-center gap-3 transition-colors cursor-pointer"
                        >
                            <FontAwesomeIcon icon={faSignOutAlt} />
                            Logout
                        </button>
                    </div>
                )}
            </div>
        </header>
    );
};

export default AdminHeader;
